function pluralize(time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}
export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour')
  } else {
    return pluralize(~~(between / 86400), ' day')
  }
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }

  if (!time) return '';

  if ((time + '').length === 10) {
    time = +time * 1000
  }

  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    date = new Date(parseInt(time))
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  if (time_str == '0/0'){
    return ''
  }
  return time_str
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}

/* 数字 格式化*/
export function nFormatter(num, digits) {
  const si = [
        { value: 1E18, symbol: 'E' },
        { value: 1E15, symbol: 'P' },
        { value: 1E12, symbol: 'T' },
        { value: 1E9, symbol: 'G' },
        { value: 1E6, symbol: 'M' },
        { value: 1E3, symbol: 'k' }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
    }
  }
  return num.toString()
}

export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

export function toThousandslsFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}


/**
 * 自定义过滤器
 */
//时间过滤器 fdetal true 返回时分秒
export function toTimeFormat(time, fdetal){
  if(!time) return '';
  if(typeof time!="string") return '';
  if(fdetal) {
    let time_str = time.replace("T", " ");
    return time_str.split(".")[0];
  }else {
    return time.split("T")[0];
  }

  // let date = new Date(time);
  // const f = {
  //   y: date.getFullYear(),
  //   m: date.getMonth() + 1,
  //   d: date.getDate(),
  //   h: date.getHours(),
  //   i: date.getMinutes(),
  //   s: date.getSeconds()
  // }
  // let time_str = f.y + "-" + f.m.toString().padStart(2, "0") + "-" + f.d.toString().padStart(2, "0");
  // if(fdetal){
  //   return time_str+=" " + f.h.toString().padStart(2, "0") + ":" + f.m.toString().padStart(2, "0") + ":" + f.s.toString().padStart(2, "0");
  // }else{
  //   return time_str;
  // }

}

/**布尔过滤器 */
export function toBool(value){
  return value ? '是' : '否';
}



export function orderStatus(value){
  let str = "";
  switch(value){
    case 10: str = "未付款"; break;
    case 20: str = "等位中"; break;
    case 30: str = "已预约"; break;
    case 35: str = "未上课"; break;
    case 40: str = "完成"; break;
    case 50: str = "已取消"; break;
  }
  return str;
}

export function orderPayType(value){
  let str = "";
  switch(value){
    case 'memberCard_number': str = "次卡"; break;
    case 'memberCard_year': str = "年卡"; break;
    case 'wepay': str = "微信"; break;
    case 'balance': str = "余额"; break;
  }
  return str;
}



// WEBPACK FOOTER //
// ./src/filters/index.js